"use strict";
class DeveloperPropertyEoiController {
    constructor($scope, $localStorage, $window, $timeout, $filter, SSHttpService, SSConfigService, SSUtilService,SSAppService, SSAlertService,OTPService,SSConfirmationService, SSUserService, SSAnalyticsService, SSStackviewService) {

        const self = this;

        self.$scope = $scope;
        self.$localStorage = $localStorage;
        self.$window = $window;
        self.$timeout = $timeout;
        self.$filter = $filter;

        self.SSHttpService = SSHttpService;
        self.SSConfigService = SSConfigService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSUserService = SSUserService;
        self.SSAnalyticsService = SSAnalyticsService;
        self.SSStackviewService = SSStackviewService;

        self.data = SHOWSUITE.data;

        self.PROPERTY_STATUS_ARCHIVED = SHOWSUITE.PROPERTY_STATUS_ARCHIVED;
        self.PROPERTY_STATUS_LISTED = SHOWSUITE.PROPERTY_STATUS_LISTED;

        self.LARAVEL_REPORT_SERVER_URL = SHOWSUITE.LARAVEL_REPORT_SERVER_URL;

        self.PROPERTY_TYPE_PRIVATE_CONDO = 1;
        self.PROPERTY_TYPE_EXECUTIVE_CONDO = 2;
        self.PROPERTY_TYPE_LANDED = 3;
        self.PROPERTY_TYPE_APARTMENT = 4;
        self.PROPERTY_TYPE_INTERGATED_DEVELOPMENT = 5;
        self.PROPERTY_TYPE_COMMERCIAL = 6;

        self.UNIT_CATEGORIES_MAP = {
            0: {code: 'XX', name: 'Other', className: 'empty'},
            1: {code: '1BR', name: '1 Bedroom', className: 'bed1'},
            2: {code: '2BR', name: '2 Bedroom', className: 'bed2'},
            3: {code: '3BR', name: '3 Bedroom', className: 'bed3'},
            4: {code: '4BR', name: '4 Bedroom', className: 'bed4'},
            5: {code: '5BR', name: '5 Bedroom', className: 'bed5'},
            6: {code: 'PH', name: 'Penthouse', className: 'ph'},
            7: {code: 'COM', name: 'Commercial', className: 'retail'},
            1000: {code: 'CT', name: 'Corner Terrace', className: 'corner-terrace'},
            2000: {code: 'IT', name: 'Intermediate Terrace', className: 'interlaced-terrace'},
            3000: {code: 'SD', name: 'Semi-Detached', className: 'semi-detached'},
            4000: {code: 'DE', name: 'Detached', className: 'detached'},
            4001: {code: 'SU', name: 'Storage Unit', className: 'retail'},
            4002: {code: 'WH', name: 'Warehouse', className: 'detached'},
        };

        self.DISCOUNT_TYPE = {
            AMOUNT: 1,
            PERCENTAGE: 2
        };

        self.unitrequest = {};
        self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
        self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;


        self.AVAILABILITY_PUBLIC = SHOWSUITE.AVAILABILITY_PUBLIC;
        self.AVAILABILITY_BROKERS_ALL = SHOWSUITE.AVAILABILITY_BROKERS_ALL;
        self.AVAILABILITY_BROKERS_TEAM = SHOWSUITE.AVAILABILITY_BROKERS_TEAM;
        self.AVAILABILITY_TEAM_LEADS = SHOWSUITE.AVAILABILITY_TEAM_LEADS;

        self.EOI_STATUS_REGISTERED = SHOWSUITE.EOI_STATUS_REGISTERED;
        self.EOI_STATUS_SUCCESSFUL = SHOWSUITE.EOI_STATUS_SUCCESSFUL;
        self.EOI_STATUS_UNSUCCESSFUL = SHOWSUITE.EOI_STATUS_UNSUCCESSFUL;
        self.EOI_STATUS_COMPLETED = SHOWSUITE.EOI_STATUS_COMPLETED;

        self.SALE_STATUS_DRAFT = SHOWSUITE.SALE_STATUS_DRAFT;
        self.SALE_STATUS_PENDING = SHOWSUITE.SALE_STATUS_PENDING;
        self.SALE_STATUS_SUBMITTED = SHOWSUITE.SALE_STATUS_SUBMITTED;
        self.SALE_STATUS_VERIFIED = SHOWSUITE.SALE_STATUS_VERIFIED;
        self.SALE_STATUS_APPROVED = SHOWSUITE.SALE_STATUS_APPROVED;
        self.SALE_STATUS_REJECTED = SHOWSUITE.SALE_STATUS_REJECTED;
        self.SALE_STATUS_OTP = SHOWSUITE.SALE_STATUS_OTP;
        self.SALE_STATUS_EXTENDED = SHOWSUITE.SALE_STATUS_EXTENDED;
        self.SALE_STATUS_SPA_ENTERED = SHOWSUITE.SALE_STATUS_SPA_ENTERED;
        self.SALE_STATUS_EXERCISED = SHOWSUITE.SALE_STATUS_EXERCISED;
        self.SALE_STATUS_DONE = SHOWSUITE.SALE_STATUS_DONE;

        self.EOI_STATUS_DRAFT = SHOWSUITE.EOI_STATUS_DRAFT;
        self.EOI_STATUS_TRANSFERRED = SHOWSUITE.EOI_STATUS_TRANSFERRED;
        self.EOI_STATUS_SUBMITTED = SHOWSUITE.EOI_STATUS_SUBMITTED;
        self.EOI_STATUS_VERIFIED = SHOWSUITE.EOI_STATUS_VERIFIED;
        self.EOI_STATUS_WITHDRAWN = SHOWSUITE.EOI_STATUS_WITHDRAWN;
        self.EOI_STATUS_REJECTED = SHOWSUITE.EOI_STATUS_REJECTED;
        self.EOI_STATUS_REGISTERED = SHOWSUITE.EOI_STATUS_REGISTERED;
        self.EOI_STATUS_SUCCESSFUL = SHOWSUITE.EOI_STATUS_SUCCESSFUL;
        self.EOI_STATUS_UNSUCCESSFUL = SHOWSUITE.EOI_STATUS_UNSUCCESSFUL;
        self.EOI_STATUS_COMPLETED = SHOWSUITE.EOI_STATUS_COMPLETED;

        self.AUTO_REFRESH_TIME = SHOWSUITE.AUTO_REFRESH_TIME;

        self.sortBy = null;
        self.sortByHeading = "Sort by...";
        self.selectedStackId = null;

        self.apiOffset = 0;
        self.apiLimit = 10;
        self.post_selected = 0;
        self.stackview = false;
        self.phase_container = false;

        self.can_add_phase = false;
        self.all_agencies_total_eois = 0;
        self.all_agencies_registered_eois = 0;
        self.property = null;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        // Trigger View Event for Eoi Page
        self.SSAnalyticsService.saveAnalyticEvent({
                event: self.SSAnalyticsService.ANALYTICS_EVENT_VIEWS_DMS_EOI,
                user_id: self.SSUtilService.getFromLocalStorage('user').id
            }
        );

        self.unit_categories = {};
        self.filtered_categories = [];
        self.total_eois_by_phase = 0;

        self.getPropertyList();
        self.initEOisStatuses();

        self.first = 2; // First choice = 2, All choices = 1
        self.viewType = 1;
        self.date = new Date();
        self.propertyIDEBalloting=-1;
        self.launchIdEBalloting=-1;
        self.eoiDateCheck = false;

        /** WEB-2860 Stack View: Need to add more details in each cell - START **/
        self.stackviewSettings = { // Init stackview_settings defaults
            show_floor_pan: false
        }
        if( self.SSStackviewService.getStackViewSettings() ){
            self.stackviewSettings = self.SSStackviewService.getStackViewSettings(self.stackviewSettings);
        }
        /** WEB-2860 Stack View: Need to add more details in each cell - END **/
        // self.getAgencies();
    }

    hasPermission(property_id) {
        const self = this;

        let url = self.$window.location.href;

        if (!url) {
            self.permission_code = 'DMS_VW_EOI / DMS_PROJ_VIEW_EOI';
            return false;
        }

        try {
            // If url ends with 'eoi' then permission name is: DMS_VW_EOI
            // If url ends with 'eois' then permission name is: DMS_PROJ_VIEW_EOI
            if (url.endsWith('eoi')) {
                if (self.SSUserService.hasPermission('DMS_VW_EOI')) {
                    return true;
                } else {
                    self.permission_code = 'DMS_VW_EOI';
                    return false;
                }
            } else if (url.endsWith('eois')) {
                if (self.SSUserService.hasPermissionForProperty('DMS_PROJ_VIEW_EOI', property_id)) {
                    return true;
                } else {
                    self.permission_code = 'DMS_PROJ_VIEW_EOI';
                    return false;
                }
            } else {
                self.permission_code = 'DMS_VW_EOI / DMS_PROJ_VIEW_EOI';
                return false;
            }
        } catch (ex) {
            console.log(ex);
        }
    }

    getPropertyList() {
        const self = this;

        self.properties = [];
        self.duplicateEoi = [];
        self.duplicateCheque = [];
        let url = 'sec/developer/properties/list';
        let params = {
            status: '30,50', // Approved, Listed
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            // WEB-2197 -- Do not show projects which are on "Archive" in the project list
            let latest_property_id = null;
            if(response.data && response.data.properties){
                $.each(response.data.properties, function(index, property){
                    if(property.status != self.PROPERTY_STATUS_ARCHIVED){
                        self.properties.push(property);

                        /** WEB-2829 DMS > Select Project drop down
                         * Select the latest property based on id **/
                        if(!latest_property_id || property.id > latest_property_id){
                            latest_property_id = property.id;
                        }
                    }
                });
            }

            if (self.data.property_id) {
                self.property_selected = self.data.property_id;
                self.getProperty(self.data.property_id);
            } else {
                if (self.properties.length > 0) {
                    /** WEB-2829 DMS > Select Project drop down
                     * Select the latest property based on id **/
                    if(latest_property_id){
                        self.property_selected = self.properties.find(p => p.id == latest_property_id).named_id;
                    }else{
                        self.property_selected = self.properties[0].named_id;
                    }
                    self.getProperty(self.property_selected);
                }
            }
        });
    }

    edit_phase(x) {
        const self = this;
        self.edited_phase = angular.copy(x);
        self.edit_mode = true;
        self.newphase = false;
        self.showUnits(x);
    }

    create_phase() {
        const self = this;

        if (!self.can_add_phase) {
            //Show error message
            self.SSAlertService.danger("Error!", "Please add at least a payment plan before proceeding adding phase.");
        } else {
            self.newphase = !self.newphase;
            self.edit_mode = false;
            self.cancelSelection(self.edited_unit);
            self.clearSelection();
        }
    }

    cancel_edit() {
        const self = this;
        self.edit_mode = false;
        self.cancelSelection(self.edited_unit);
        self.clearSelection();
    }

    getProperty(propertyId, x) {
        const self = this;
        self.show_phases = false;

        self.data.property_id = propertyId;
        if (!self.data.property_id)
            return;

        self.unitEoiByPhase = {};
        let url = 'sec/developer/properties/' + self.data.property_id;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.property = response.data.property;
            self.named_id = self.property.named_id;
            self.stats = response.data.stats;
            self.typeMaps = response.data.type_map;
            self.unitTypes = response.data.unit_types;
            self.launch_id = "";

            //self.getPromotionCodes();
            self.getAgenciesByProperty(propertyId, 1, null)
            self.getPhase();
            self.getPaymentPlans();
            //self.getUnitsEoi();
            //self.getEoiByCategory();
        });


    }

    getPromotionCodes() {
        const self = this;
        if (!self.property)
            return;

        self.phase = null;
        self.phase_master = null;
        self.availability = {};
        self.propertyLaunch = {};

        let url = 'sec/developer/promotion-codes/get';

        let params = {
            'property_id': self.property.id,
            'limit': 1000
        };


        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.promotion_codes = response.data.promotion_codes;
            // self.getPhase();
        });
    }

    getPhase(show_loading = true) {
        const self = this;
        if (!self.property)
            return;

        self.phase = null;
        self.phase_master = null;
        self.availability = {};
        self.propertyLaunch = {};
        let EoiPropertyLaunch = [];

        let url = 'sec/developer/properties/' + self.property.id + '/launches';

        if(show_loading){
            loading(true);
        }

        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //self.property_launches = response.data.property_launches;
            self.phase = response.data;
            self.phase_master = angular.copy(self.phase);

            self.propertyLaunches = response.data.property_launches;

            jQuery.each(self.propertyLaunches, function (i, Eoi) {

                if (EoiPropertyLaunch) {
                    EoiPropertyLaunch = EoiPropertyLaunch.concat(Eoi.id);
                } else {
                    EoiPropertyLaunch = Eoi.id;
                }

            });

            if (EoiPropertyLaunch) {
                self.EoiPropertyLaunch = self.getUniqueArray(EoiPropertyLaunch);
                self.EoiPropertyLaunchAll = self.getUniqueArray(EoiPropertyLaunch);
            }

            jQuery.each(self.phase.property_launches, function (i, propertyLaunch) {
                propertyLaunch.promotion_codes = [];
                var current_date = moment().toISOString();
                var start_date = moment(propertyLaunch.eoi_start_date).utc().format('YYYY-MM-DD HH:mm:ss');
                if (current_date < start_date) {
                    propertyLaunch.upcoming_phase = true;
                    self.phase.property_launches.enable_upcoming_phase = true;
                }
                jQuery.each(self.promotion_codes, function (i, unit) {

                    if (unit.unit_ids != null && unit.unit_ids != '') {
                        var promotion_units = unit.unit_ids.split(",");
                        jQuery.each(promotion_units, function (i, promo_unit) {

                            if (jQuery.inArray(parseInt(promo_unit), propertyLaunch.units) !== -1) {
                                if (jQuery.inArray(parseInt(unit.id), propertyLaunch.promotion_codes) === -1) {
                                    propertyLaunch.promotion_codes.push(parseInt(unit.id));
                                }
                            }
                        });
                    }

                });

                if (propertyLaunch.eoi_start_date) {
                    var stillUtc = moment.utc(propertyLaunch.eoi_start_date).toDate();
                    var local = moment(stillUtc).local().format('DD/MM/YYYY HH:mm');

                    //propertyLaunch.eoi_start_date = self.$filter('date')(propertyLaunch.eoi_start_date, "dd/MM/yyyy HH:mm:ss");
                    propertyLaunch.eoi_start_date = local;
                }
                if (propertyLaunch.eoi_end_date) {
                    var stillUtc = moment.utc(propertyLaunch.eoi_end_date).toDate();
                    var local = moment(stillUtc).local().format('DD/MM/YYYY HH:mm');
                    propertyLaunch.eoi_end_date = local;
                    // propertyLaunch.eoi_end_date = self.$filter('date')(propertyLaunch.eoi_end_date, "dd/MM/yyyy HH:mm:ss");
                }
                if (propertyLaunch.launch_start_date) {
                    var stillUtc = moment.utc(propertyLaunch.launch_start_date).toDate();
                    var local = moment(stillUtc).local().format('DD/MM/YYYY HH:mm');
                    propertyLaunch.launch_start_date = local;
                    // propertyLaunch.launch_start_date= self.$filter('date')(propertyLaunch.launch_start_date, "dd/MM/yyyy HH:mm:ss");
                }
                if (propertyLaunch.launch_end_date) {
                    var stillUtc = moment.utc(propertyLaunch.launch_end_date).toDate();
                    var local = moment(stillUtc).local().format('DD/MM/YYYY HH:mm');
                    propertyLaunch.launch_end_date = local;
                }

            });

            self.propertyLaunch.eoi_start_date = '';
            self.propertyLaunch.eoi_end_date = '';
            self.propertyLaunch.launch_start_date = '';
            self.propertyLaunch.launch_end_date = '';

            self.getUnits(show_loading);
        });

        // Temp disabling of auto refresh
        // Auto refresh
        // self.$timeout(function() {
        //   self.getPhase(false);
        // }, self.AUTO_REFRESH_TIME? self.AUTO_REFRESH_TIME : 10*1000);
    }

    getUnits(show_loading = true) {

        const self = this;
        if (!self.property.id)
            return;

        self.units = null;

        let url = 'properties/' + self.property.id + '/stacks';
        let params = {

            'return_property': true,
            'property_columns': 'id,named_id,name,type,product_type,status,location,country,region',
            'return_stack': true,
            'stack_columns': 'id,named_id,name',
            'include_units': true,
            'unit_columns': 'id,named_id,floor_no,floor_order,unit_no,unit_order,house_no,category,type,name,baths,status,price,start_price,end_price,size_ft2,psf'
        };


        if(show_loading){
            loading(true);
        }

        self.SSHttpService.getAPIRequest(url,params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //self.property_launches = response.data.property_launches;

            self.units = response.data.property_stacks;
            if (self.property) {
                self.propertys_id = self.property.id;
            }

            /*
            jQuery.each(self.phase.property_launches, function (i, agency) {

                if (agency.eoi_start_date) {
                    agency.eoi_start_date = agency.eoi_start_date.split(" ", 2);
                    agency.eoi_start_date = self.$filter('date')(agency.eoi_start_date[0], "dd/MM/yyyy");
                }
                if (agency.eoi_end_date) {
                    agency.eoi_end_date = agency.eoi_end_date.split(" ", 2);
                    agency.eoi_end_date = self.$filter('date')(agency.eoi_end_date[0], "dd/MM/yyyy");
                }
                if (agency.launch_start_date) {
                    agency.launch_start_date=agency.launch_start_date.split(" ", 2);
                    agency.launch_start_date= self.$filter('date')(agency.launch_start_date[0], "dd/MM/yyyy");
                }
                if (agency.launch_end_date) {
                    agency.launch_end_date=agency.launch_end_date.split(" ", 2);
                    agency.launch_end_date= self.$filter('date')(agency.launch_end_date[0], "dd/MM/yyyy");
                }

            });
            console.log(self.phase.property_launches);

            */
            self.propertyIDEBalloting = self.property.id;

            self.getPropertyStacks(self.property.id);
        });
    }

    getAgencies() {
        const self = this;

        self.agencies = [];
        let params = {
            'format': 1
        };

        loading(true);
        self.SSHttpService.getAPIRequest('agencies', params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!(response.data && response.data.agencies)) {
                return;
            }

            self.agencies = response.data.agencies;

            self.filterAvailableAgencies();
            self.getPropertyAgencies();
            self.getAppointedAgencies();
        });
    }


    getAgenciesByProperty(PropertyId, type, LaunchId) {
        const self = this;

        let url = 'sec/developer/agencies/';

        let param = {
            property_id: PropertyId
        };


        loading(true);
        self.SSHttpService.getAPIRequest(url, param).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!(response.data)) {
                return;
            }

            self.propertyAgency = response.data;
            self.getAllagencies(PropertyId, type, LaunchId);

        });

    }


    getAllagencies(PropertyId, type, LaunchId) {
        const self = this;

        let url = 'agencies';

        let params = {
            format: 1
        };


        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!(response.data)) {
                return;
            }

            self.allAgencies = response.data;
            self.getUnitsEoi(PropertyId, type, LaunchId);

        });

    }


    getPropertyAgencies() {
        const self = this;

        self.agency_list = null;
        self.projectAgency = null;

        let url = 'sec/developer/agencies/';


        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!(response.data)) {
                return;
            }

            self.agency_list = response.data;


            jQuery.each(self.agency_list.property_agencies, function (i, agency) {
                self.projectAgency = null;
                self.projectAgency = self.getAgencyName(agency.agency_id);

                if (self.projectAgency) {

                    self.agency_list.property_agencies[i].agency_name = self.getAgencyName(agency.agency_id);

                }

            });


        });

    }


    getAppointedAgencies() {
        const self = this;

        self.appoint_agency_list = null;
        self.appoint_projectAgency = null;
        self.agency_iddd = {};

        let url = 'sec/developer/agencies/';

        let params = {
            property_id: self.data.property_id,

        };


        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!(response.data)) {
                return;
            }

            self.appoint_agency_list = response.data;


            jQuery.each(self.appoint_agency_list.property_agencies, function (i, agency) {
                self.appoint_projectAgency = null;
                self.appoint_projectAgency = self.getAgencyName(agency.agency_id);
                self.agency_iddd[agency.id] = agency.agency_id;

                if (self.appoint_projectAgency) {

                    self.appoint_agency_list.property_agencies[i].agency_name = self.getAgencyName(agency.agency_id);

                }

            });
        });
    }

    savePhase(propertyLaunch, property_id) {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to make this change?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function (confirmationStatus, id) {

                self.OTPService.getVerified(
                    self.OTPService.TYPE_SESSION_2FA,
                    function (otpStatus, id) {
                        self._savePhase(propertyLaunch, property_id);
                    }
                );
            }
        );
    }


    updatePhase(propertyLaunch) {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to make this change?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function (confirmationStatus) {

                self.OTPService.getVerified(
                    self.OTPService.TYPE_SESSION_2FA,
                    function (otpStatus) {
                        self._updatePhase(propertyLaunch);
                    }
                );
            }
        );
    }

    _savePhase(propertyLaunch, property_id) {

        const self = this;

        if (!self.SSUtilService.validateForm(self, 'ctrl', jQuery('#addphase')))
            return;

        let eoi_start = propertyLaunch.eoi_start_date;
        let eoi_end = propertyLaunch.eoi_end_date;
        let eoi_launch_start_date = propertyLaunch.launch_start_date;

        if (typeof eoi_start == undefined || typeof eoi_end == undefined || typeof eoi_launch_start_date == undefined) {
            self.SSAlertService.danger("Please enter start date, end date");
        }

        if (propertyLaunch.eoi_start_date != '' && propertyLaunch.eoi_start_date != null) {
            var split_date = propertyLaunch.eoi_start_date.split(" ", 2);
            var res = split_date[0].split("/", 3);
            var eoi_start_date_format = res[2] + '-' + res[1] + '-' + res[0] + ' ' + split_date[1];
        }

        if (propertyLaunch.eoi_end_date != '' && propertyLaunch.eoi_end_date != null) {
            var split_date = propertyLaunch.eoi_end_date.split(" ", 2);
            var res_end = split_date[0].split("/", 3);
            var eoi_end_date_format = res_end[2] + '-' + res_end[1] + '-' + res_end[0] + ' ' + split_date[1];
        }
        if (propertyLaunch.launch_start_date != '' && propertyLaunch.launch_start_date != null) {
            var split_date = propertyLaunch.launch_start_date.split(" ", 2);
            var res_launch_start_date = split_date[0].split("/", 3);
            var eoi_launch_start_date_format = res_launch_start_date[2] + '-' + res_launch_start_date[1] + '-' + res_launch_start_date[0] + ' ' + split_date[1];
        }
        if (propertyLaunch.launch_end_date != '' && propertyLaunch.launch_end_date != null) {
            var split_date = propertyLaunch.launch_end_date.split(" ", 2);
            var res_launch_end_date = split_date[0].split("/", 3);
            var eoi_launch_end_date_format = res_launch_end_date[2] + '-' + res_launch_end_date[1] + '-' + res_launch_end_date[0] + ' ' + split_date[1];
        }


        if (eoi_start_date_format) {
            var start_localDate = new Date(self.parseDate(eoi_start_date_format + ':00'));
            var start_utcFormat = moment(start_localDate).utc().format('YYYY-MM-DD HH:mm:ss');
        }
        if (eoi_end_date_format) {
            var end_localDate = new Date(self.parseDate(eoi_end_date_format + ':00'));
            var end_utcFormat = moment(end_localDate).utc().format('YYYY-MM-DD HH:mm:ss');
        }
        if (eoi_launch_start_date_format) {
            var launch_localDate = new Date(self.parseDate(eoi_launch_start_date_format + ':00'));
            var launch_start_utcFormat = moment(launch_localDate).utc().format('YYYY-MM-DD HH:mm:ss');
        }
        if (eoi_launch_end_date_format) {
            var launch_localDate = new Date(self.parseDate(eoi_launch_end_date_format + ':00'));
            var launch_end_utcFormat = moment(launch_localDate).utc().format('YYYY-MM-DD HH:mm:ss');
        }

        self.checkDateExists(eoi_start, eoi_end, eoi_launch_start_date, null, function (conflict) {
            if (!conflict)
                return;

            let url = 'sec/developer/properties/' + property_id + '/launches';
            self.registerErrors = null;
            let params = {
                name: propertyLaunch.name,
                eoi_start_date: start_utcFormat,
                eoi_end_date: end_utcFormat,
                launch_start_date: launch_start_utcFormat,
                launch_end_date: launch_end_utcFormat,
                availability: propertyLaunch.availability,
                post_launch_availability: propertyLaunch.post_launch_availability,
                units: self.new_selected_units,
                booking_session_minutes: propertyLaunch.booking_session_minutes,
                booking_session_extension_minutes: propertyLaunch.booking_session_extension_minutes
            };

            propertyLaunch.units = self.new_selected_units;
            propertyLaunch.property_id = property_id;

            loading(true);
            self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                loading(false);


                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    self.registerError = self.SSHttpService.parseErrors(response);
                    return;
                }


                self.newphaseCreated = response.data.property_launch;
                self.propertyLaunch.id = self.newphaseCreated.id;
                self.phase.property_launches.push(propertyLaunch);
                self.registerError = null;
                self.newphase = false;

                self.SSAlertService.success('Property Launch created successfully.');


            });
        });

    }


    checkDateExists(eoi_start, eoi_end, eoi_launch_start_date, propertyLaunchId = null, callback) {
        const self = this;
        var conflict = true;

        if (!eoi_start || !eoi_end || !eoi_launch_start_date) {
            conflict = false;
            self.SSAlertService.danger('Please enter Eoi Start, Eoi End and Eoi Launch Date');
            callback(conflict);
        }

        if (!self.phase)
            return false;

        jQuery.each(self.phase.property_launches, function (i, launch) {
            var launch_start = moment(launch.eoi_start_date, 'DD/MM/YYYY HH:mm').utc().format('YYYY-MM-DD HH:mm:ss');
            var launch_end = moment(launch.eoi_end_date, 'DD/MM/YYYY HH:mm').utc().format('YYYY-MM-DD HH:mm:ss');
            var launch_launch_start = moment(launch.eoi_launch_start_date, 'DD/MM/YYYY HH:mm').utc().format('YYYY-MM-DD HH:mm:ss');

            var eoi_start_date = moment(eoi_start, 'DD/MM/YYYY HH:mm').utc().format('YYYY-MM-DD HH:mm:ss');
            var eoi_launch_start_date = moment(eoi_launch_start_date, 'DD/MM/YYYY HH:mm').utc().format('YYYY-MM-DD HH:mm:ss');
            var eoi_end_date = moment(eoi_end, 'DD/MM/YYYY HH:mm').utc().format('YYYY-MM-DD HH:mm:ss');

            if ((launch_start > eoi_start_date && launch_start < eoi_launch_start_date) || (launch_end > eoi_start_date && launch_end < eoi_launch_start_date)
                || (launch_launch_start > eoi_start_date && launch_launch_start < eoi_launch_start_date)) {
                if (propertyLaunchId != launch.id)
                    conflict = false;
                self.SSAlertService.danger('Phase already exists within the date range. Please enter new date');
                return false;
            }
        });

        callback(conflict);
    }

    LocaltoUTC(date) {
        const self = this;
        date = new Date(date);
        //Local time converted to UTC
        //  var localOffset = date.getTimezoneOffset() * 60000;
        //  var localTime = date.getTime();
        //  date = localTime - localOffset;
        //  date = new Date(date);


        var dtes = date.toUTCString();

        var dtesobj = new Date(dtes);

        var dataes = self.dateFormat(dtesobj);

        self.UtctoLocal(date.toUTCString());
    }


    UtctoLocal(UTCDateString) {

        const self = this;
        var convertdLocalTime = new Date(UTCDateString);

        var hourOffset = convertdLocalTime.getTimezoneOffset() / 60;

        convertdLocalTime.setHours(convertdLocalTime.getHours() - hourOffset);

        var dateObj = new Date(convertdLocalTime);

        var dataes = self.dateFormat(dateObj);
        console.log("func date" + dataes);

        console.log("LOCAL TIme" + convertdLocalTime.toGMTString());

    }

    dateFormat(now) {
        const self = this;
        var year = "" + now.getFullYear();
        var month = "" + (now.getMonth() + 1);
        if (month.length == 1) {
            month = "0" + month;
        }
        var day = "" + now.getDate();
        if (day.length == 1) {
            day = "0" + day;
        }
        var hour = "" + now.getHours();
        if (hour.length == 1) {
            hour = "0" + hour;
        }
        var minute = "" + now.getMinutes();
        if (minute.length == 1) {
            minute = "0" + minute;
        }
        var second = "" + now.getSeconds();
        if (second.length == 1) {
            second = "0" + second;
        }
        return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
    }

    parseDate(date) {

        const self = this;
        const parsed = Date.parse(date);
        if (!isNaN(parsed)) {
            return parsed;
        }

        return Date.parse(date.replace(/-/g, '/').replace(/[a-z]+/gi, ' '));
    }

    _updatePhase(propertyLaunch) {

        const self = this;
        self.phase_container = false;
        self.selected_units_phase = null;
        self.post_selected++;


        jQuery.each(self.phase.property_launches, function (i, phase) {

            phase.currentSelection = true;

        });

        if (self.edited_unit) {
            self.edited_unit.currentSelection = false;
        }
        self.selected_units = self.stacks;

        jQuery.each(self.stacks, function (i, stacks) {
            jQuery.each(stacks.availableUnits, function (j, unit_data) {
                if (unit_data.clickedclass & unit_data.clickedclass == true) {
                    if (self.selected_units_phase != null) {
                        self.selected_units_phase = self.selected_units_phase + ',' + unit_data.id;
                    } else {
                        self.selected_units_phase = unit_data.id;
                    }
                }
            });
        });

        if (self.edited_unit) {
            // self.edited_unit.units = self.selected_units_phase;
            propertyLaunch.selectedUnits = self.selected_units_phase;
        }

        if (self.edited_unit) {
            self.edited_unit.updated_units = self.selected_units_phase_arr;
        }

        if (!self.SSUtilService.validateForm(self, 'ctrl', jQuery('#updatephase')))
            return;

        if (!propertyLaunch.selectedUnits) {
            // Un-selecting units is not working
            // https://showsuite.atlassian.net/browse/WEB-1941 [9-July-20]
            // If selectedUnits are null/empty then don't copy from 'units'

            self.SSAlertService.danger('​A phase should have at least one unit attached. Cannot save empty phase.');
            return;
        } else {
            if (propertyLaunch.selectedUnits instanceof Array) {
                propertyLaunch.selectedUnits = propertyLaunch.selectedUnits.toString();
            }
        }


        let eoi_start = propertyLaunch.eoi_start_date;
        let eoi_end = propertyLaunch.eoi_end_date;
        let eoi_launch_start_date = propertyLaunch.launch_start_date;
        // let eoi_launch_end_date = propertyLaunch.launch_end_date;

        if (typeof eoi_start == undefined || typeof eoi_end == undefined || typeof eoi_launch_start_date == undefined) {
            self.SSAlertService.danger("Please enter start date, end date");
        }

        if (propertyLaunch.eoi_start_date != '' && propertyLaunch.eoi_start_date != null) {
            var split_time = propertyLaunch.eoi_start_date.split(" ", 2);
            var res = split_time[0].split("/", 3);
            var eoi_start_date_format = res[2] + '-' + res[1] + '-' + res[0] + ' ' + split_time[1];
        }

        if (propertyLaunch.eoi_end_date != '' && propertyLaunch.eoi_end_date != null) {
            var split_time = propertyLaunch.eoi_end_date.split(" ", 2);
            var res_end = split_time[0].split("/", 3);
            var eoi_end_date_format = res_end[2] + '-' + res_end[1] + '-' + res_end[0] + ' ' + split_time[1];
        }
        if (propertyLaunch.launch_start_date != '' && propertyLaunch.launch_start_date != null) {
            var split_time = propertyLaunch.launch_start_date.split(" ", 2);
            var res_launch = split_time[0].split("/", 3);
            var eoi_launch_start_date_format = res_launch[2] + '-' + res_launch[1] + '-' + res_launch[0] + ' ' + split_time[1];
        }
        if (propertyLaunch.launch_end_date != '' && propertyLaunch.launch_end_date != null) {
            var split_time = propertyLaunch.launch_end_date.split(" ", 2);
            var res_launch = split_time[0].split("/", 3);
            var eoi_launch_end_date_format = res_launch[2] + '-' + res_launch[1] + '-' + res_launch[0] + ' ' + split_time[1];
        }


        if (eoi_start_date_format) {
            var start_localDate = new Date(self.parseDate(eoi_start_date_format + ':00'));
            var eoi_start_date_format = moment(start_localDate).utc().format('YYYY-MM-DD HH:mm:ss');
        }
        if (eoi_end_date_format) {
            var end_localDate = new Date(self.parseDate(eoi_end_date_format + ':00'));
            var eoi_end_date_format = moment(end_localDate).utc().format('YYYY-MM-DD HH:mm:ss');
        }
        if (eoi_launch_start_date_format) {
            var launch_start_localDate = new Date(self.parseDate(eoi_launch_start_date_format + ':00'));
            var eoi_launch_start_date_format = moment(launch_start_localDate).utc().format('YYYY-MM-DD HH:mm:ss');
        }
        if (eoi_launch_end_date_format) {
            var launch_end_localDate = new Date(self.parseDate(eoi_launch_end_date_format + ':00'));
            var eoi_launch_end_date_format = moment(launch_end_localDate).utc().format('YYYY-MM-DD HH:mm:ss');
        }


        self.checkDateExists(eoi_start, eoi_end, eoi_launch_start_date, propertyLaunch.id, function (conflict) {
            if (!conflict)
                return;
            let url = 'sec/developer/properties/' + propertyLaunch.property_id + '/launches/' + propertyLaunch.id;
            self.registerErrors = null;
            let params = {
                name: propertyLaunch.name,
                eoi_start_date: eoi_start_date_format,
                eoi_end_date: eoi_end_date_format,
                launch_start_date: eoi_launch_start_date_format,
                launch_end_date: eoi_launch_end_date_format,
                availability: propertyLaunch.availability,
                post_launch_availability: propertyLaunch.post_launch_availability,
                authorisation_enabled: propertyLaunch.authorisation_enabled,
                units: propertyLaunch.selectedUnits,
                booking_session_minutes: propertyLaunch.booking_session_minutes,
                booking_session_extension_minutes: propertyLaunch.booking_session_extension_minutes
            };
            //console.log(params);
            propertyLaunch.err_code = false;

            loading(true);
            self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                loading(false);


                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    self.registerErrors = self.SSHttpService.parseErrors(response);
                    propertyLaunch.err_code = true;
                    return;
                }

                jQuery.each(self.phase.property_launches, function (i, phase) {

                    phase.currentSelection = true;

                });
                propertyLaunch.currentSelection = false;

                //self.updatedPhase = response.data;
                propertyLaunch = response.data.property_launch;
                //propertyLaunch.units=self.selected_units_phase;
                //console.log(self.updatedPhase);
                propertyLaunch.editable = propertyLaunch.editable ? false : true;

                var current_date = moment().toISOString();
                var start_date = moment(propertyLaunch.eoi_start_date).utc().format('YYYY-MM-DD HH:mm:ss');
                if (current_date < start_date) {
                    propertyLaunch.upcoming_phase = true;
                    self.phase.property_launches.enable_upcoming_phase = true;
                }

                if (propertyLaunch.eoi_start_date) {
                    var stillUtc = moment.utc(propertyLaunch.eoi_start_date).toDate();
                    var local = moment(stillUtc).local().format('DD/MM/YYYY HH:mm');

                    //agency.eoi_start_date = self.$filter('date')(agency.eoi_start_date, "dd/MM/yyyy HH:mm:ss");
                    propertyLaunch.eoi_start_date = local;
                }
                if (propertyLaunch.eoi_end_date) {
                    var stillUtc = moment.utc(propertyLaunch.eoi_end_date).toDate();
                    var local = moment(stillUtc).local().format('DD/MM/YYYY HH:mm');
                    propertyLaunch.eoi_end_date = local;
                    // agency.eoi_end_date = self.$filter('date')(agency.eoi_end_date, "dd/MM/yyyy HH:mm:ss");
                }
                if (propertyLaunch.launch_start_date) {
                    var stillUtc = moment.utc(propertyLaunch.launch_start_date).toDate();
                    var local = moment(stillUtc).local().format('DD/MM/YYYY HH:mm');
                    propertyLaunch.launch_start_date = local;
                }

                propertyLaunch.editable = false;

                jQuery.each(self.phase.property_launches, function (i, phase) {
                    if (parseInt(phase.id) == parseInt(propertyLaunch.id)) {
                        self.phase.property_launches[i] = propertyLaunch;
                    }
                });
                self.SSAlertService.success('Property Launch updated successfully.');
                self.edit_mode = false;
                self.newphase = false;

            });
        });


    }


    toggleEdit(x, mode) {
        const self = this;
        x.editable = x.editable ? false : true;
        x.updated_units = x.units;
        if (mode == 'edit') {
            x.backup = angular.copy(x);
        } else if (mode == 'cancel') {
            x = angular.merge(x, x.backup);
            delete x.backup;
            x.editable = x.editable ? false : true;
            // self.x_edit='';
        }


    }

    deleteAgencies(id, arr_id) {

        const self = this;

        let url = 'sec/developer/agencies/remove';
        let params = {

            property_id: self.property.id,
            agency_id: id,
        };


        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.registerErrors = self.SSHttpService.parseErrors(response);
                return;
            }

            self.appoint_agency_list.property_agencies.splice(arr_id, 1)
            self.SSAlertService.success('Agency deleted successfully.');


        });

    }


    deletePhase(propertyLaunch, arr_id) {

        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to make this change?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function (confirmationStatus) {

                self.OTPService.getVerified(
                    self.OTPService.TYPE_SESSION_2FA,
                    function (otpStatus) {
                        self._deletePhase(propertyLaunch, arr_id);
                    }
                );
            }
        );
    }

    _deletePhase(propertyLaunch, arr_id) {

        const self = this;

        let url = 'sec/developer/properties/' + propertyLaunch.property_id + '/launches/' + propertyLaunch.id + '/delete';
        let params = {

            propertyId: propertyLaunch.property_id,
            propertyLaunchId: propertyLaunch.id,
        };


        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.registerErrors = self.SSHttpService.parseErrors(response);
                return;
            }

            self.phase.property_launches.splice(arr_id, 1)
            self.SSAlertService.success('Property Launch deleted successfully.');


        });

    }


    updateAgencies(id, sno, commission, vals) {

        const self = this;

        let url = 'sec/developer/agencies/update';
        self.registerErrors = null;
        let params = {
            property_id: self.property.id,
            agency_id: id,
            agency_commission: commission,
        };


        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.registerErrors = self.SSHttpService.parseErrors(response);
                return;
            }


            self.registerErrors = null;

            self.appoint_agency_list.property_agencies[vals].agency_commission = commission;

            self.SSAlertService.success('Agency details updated successfully.');
            self.editorEnabled[sno] = !self.editorEnabled[sno];
            self.savevar[sno] = false

        });

    }

    filterAvailableAgencies() {
        const self = this;

        self.availableAgencies = [{
            id: null,
            name: "Please Select"
        }];

        if (self.agencies) {
            jQuery.each(self.agencies, function (i, agency) {
                let projectAgency = self.findProjectAgency(agency.id);
                if (!projectAgency) {
                    self.availableAgencies.push({
                        id: agency.id,
                        name: agency.name
                    });
                }
            });
        }

    }

    findAgency(agencyId) {
        const self = this;

        let agency = null;

        if (self.agencies) {
            jQuery.each(self.agencies, function (i, _agency) {
                if (agencyId == _agency.id) {
                    agency = _agency;
                    return false;
                }
            });
        }

        return agency;
    }

    getAgencyName(agencyId) {
        const self = this;

        let agency = self.findAgency(agencyId);

        return agency ? agency.name : '';
    }

    findProjectAgency(agencyId) {
        const self = this;

        let projectAgency = null;

        if (self.projectAgencies) {
            jQuery.each(self.projectAgencies, function (i, _projectAgency) {
                if (agencyId == _projectAgency.agency_id) {
                    projectAgency = _projectAgency;
                    return false;
                }
            });
        }

        return projectAgency;
    }

    toggleProjectAgencyForm(agencyId) {
        const self = this;

        self.showProjectAgencyForm = !self.showProjectAgencyForm;

        if (self.showProjectAgencyForm) {
            let projectAgency = self.findProjectAgency(agencyId);
            if (projectAgency) {
                self.projectAgencyParams = angular.copy(projectAgency);
            } else {
                self.projectAgencyParams = {
                    property_id: self.property.id
                };
            }
            self.projectAgencyErrors = {};
        }
    }

    assignAgency() {
        const self = this;

        if (!self.SSUtilService.validateForm(self, 'ctrl', jQuery('#AssignProjectAgencyForm'))) {
            self.SSAlertService.warning('Missing Params!', 'Please fill in the required information.');
            return;
        }

        self.projectAgencyErrors = {};


        let url = 'sec/developer/agencies/assign';
        if (self.projectAgencyParams.id) {
            url = 'sec/developer/agencies/update';
        }

        loading(true);
        self.SSHttpService.postAPIRequest(url, self.projectAgencyParams).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.projectAgencyErrors = self.SSHttpService.parseErrors(response);
                return;
            }

            if (!self.projectAgencies) {
                self.projectAgencies = [];
            }

            let projectAgency = self.findProjectAgency(self.projectAgencyParams.agency_id);
            if (projectAgency) {
                angular.merge(projectAgency, response.data.agency_project);
            } else {
                self.projectAgencies.push(response.data.agency_project);
            }

            self.toggleProjectAgencyForm();
            self.filterAvailableAgencies();

        });
    }

    removeAgency(agencyId) {
        const self = this;

        let url = 'sec/developer/agencies/remove';
        let params = {
            property_id: self.property.id,
            agency_id: agencyId
        };

        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            self.progressUploadingFiles = false;
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (self.projectAgencies) {
                jQuery.each(self.projectAgencies, function (i, _projectAgency) {
                    if (agencyId == _projectAgency.agency_id) {
                        self.projectAgencies.splice(i, 1);
                        return false;
                    }
                });
            }

            self.filterAvailableAgencies();

        });
    }

    toggle_stack_view() {
        const self = this;
        self.stackview = self.stackview ? false : true;
        self.add_promo_code = self.add_promo_code ? false : true;
    }


    toggle_phase_view() {
        const self = this;
        self.phase_container = self.phase_container ? false : true;
    }

    toggle_promo_code_view() {
        const self = this;
        self.promo_code_container = self.promo_code_container ? false : true;

    }

    genPasscode(x) {

        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to make this change?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function (confirmationStatus) {

                self.OTPService.getVerified(
                    self.OTPService.TYPE_SESSION_2FA,
                    function (otpStatus) {
                        self._genPasscode(x);
                    }
                );
            }
        );

    }

    _genPasscode(x) {

        const self = this;

        let url = 'sec/developer/properties/' + x.property_id + '/launches/' + x.id + '/authorisation-code';
        self.registerErrors = null;

        let params = {
            propertyId: x.property_id,
            propertyLaunchId: x.id,
        };


        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.registerErrors = self.SSHttpService.parseErrors(response);
                return;
            }

            self.SSAlertService.success('Authorization passcode generated successfully.');

        });

    }

    viewPasscode(x) {
        const self = this;

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function (otpStatus) {
                self._viewPasscode(self.edited_phase);
            }
        );
    }

    _viewPasscode(x) {

        const self = this;

        if (!x.hasOwnProperty("id")) {
            x = self.edited_phase;
        }

        let url = 'sec/developer/properties/' + x.property_id + '/launches/' + x.id + '/authorisation-code';
        self.registerErrors = null;

        let params = {
            propertyId: x.property_id,
            propertyLaunchId: x.id,
        };


        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.registerErrors = self.SSHttpService.parseErrors(response);
                return;
            }
            self.AuthCode = response.data.authorisation_code;
            self.AuthCode_status = true;
            $('#authCode').modal('show');


        });

    }


    getPropertyStacks(propertyId) {
        const self = this;

        self.stacks = self.units;
        self.stacks_promocodes = angular.copy(self.units);

        self.processServerData();
        self.getPropertyUnitTypes();

        self.isEoiAccessible = !!self.SSUserService.getActivePropertyLaunchForEoiCreate(self.property, 'EOI');

        // self.getAllPropertyLaunch(propertyId, 1, null);

        if (self.EoiPropertyLaunchAll && self.EoiPropertyLaunchAll.length === 1) {
            // If property have single phase, then preselect and load
            self.launch_id = "" + self.EoiPropertyLaunchAll[0]; // String
            self.getUnitsEoi(self.property.id, self.first, self.launch_id)
        }
    }

    processServerData() {
        const self = this;

        jQuery.each(self.stacks, function (i, stack) {
            stack.floorsData = self.SSUtilService.getFloorWiseUnits(stack.units);
            stack.availableUnits = self.filterAvailableUnits(stack.units);
            self.availableUnits = stack.availableUnits;
            self.loadUnits();
        });

        jQuery.each(self.stacks_promocodes, function (i, stack) {
            stack.floorsData = self.SSUtilService.getFloorWiseUnits(stack.units);
            stack.availableUnits = self.filterAvailableUnits(stack.units);
            self.availableUnits = stack.availableUnits;
            self.loadUnits();
        });

        self.availableUnits = self.SSUtilService.getSortedUnits(self.availableUnits, false, 'named_id');

        // Select first stack by default
        if (self.stacks.length > 0) {
            self.selectedStackId = '';
            self.selectedStackId = (self.selectedStackId) ? self.selectedStackId : self.stacks[0].id;
        }

        if (self.stacks_promocodes.length > 0) {
            self.selectedStackIdPromoCode = '';
            self.selectedStackIdPromoCode = (self.selectedStackIdPromoCode) ? self.selectedStackIdPromoCode : self.stacks_promocodes[0].id;
        }
        self.SSAppService.isPageLoaded = true;
    }

    getPropertyUnitTypes() {
        const self = this;

        self.propertyUnitCategories = [];

        jQuery.each(self.stacks, function (i, stack) {
            jQuery.each(stack.units, function (j, unit) {
                let category = null;
                if (unit.category in self.UNIT_CATEGORIES_MAP) {
                    category = self.UNIT_CATEGORIES_MAP[unit.category];
                } else {
                    category = self.UNIT_CATEGORIES_MAP[0];
                }

                if (self.propertyUnitCategories.indexOf(category) == -1) {
                    self.propertyUnitCategories.push(category);
                }
            });
        });

    }

    getEoiByCategory() {

        const self = this;

        self.unitDetails = [];
        self.unitCats = [];
        self.categoryList = [];
        self.EoiCategoryCount = {};

        let cats = {};

        //all selection
        jQuery.each(self.EoiUnits, function (i, unit) {
            jQuery.each(self.stacks, function (j, stacks) {
                jQuery.each(stacks.units, function (k, unit_data) {
                    //

                    if (unit_data.id == unit) {
                        //unit_data.countEoi=unit;
                        self.unitDetails.push(unit_data.category);
                    }

                });
            });

        });

        self.EoiCategoryCount = self.unitDetails.reduce(function (acc, curr) {
            if (typeof acc[curr] == 'undefined') {
                acc[curr] = 1;
            } else {
                acc[curr] += 1;
            }

            return acc;
        }, {});

        jQuery.each(self.EoiCategoryCount, function (i, category) {
            cats = {};
            cats.id = self.SSConfigService.getUnitCategoryName(i);
            cats.name = category;
            self.unitCats.push(cats);
        });

    }

    filterEoiByCategory(launch_id, choice_type = 1){
        const self = this;

        // All choices = 1
        // First choice = 2

        self.unit_categories = {};
        self.filtered_categories = [];

        let eoi_units = [];

        try{

            $.each(self.allEoisByPhase, function(index, eoi){
                if(eoi.property_launch_id == launch_id){

                    let units = JSON.parse(eoi.units);

                    if(choice_type == 2 && units && units.length > 0){
                        $.each(units, function(i, unitArr){
                            $.each(unitArr, function(j, unit){
                                if(j == 0){
                                    eoi_units.push(unit);
                                }
                            });
                        });
                        // eoi_units.push(units[0]);
                    }
                    else{
                        units = _.flattenDeep(JSON.parse(eoi.units));
                        $.each(units, function(u, unit){
                            eoi_units.push(unit);
                        });
                    }
                }
            });

            $.each(eoi_units, function (i, unit_id) {
                $.each(self.stacks, function(j, stack){
                    $.each(stack.units, function(k, unit){

                        if (unit.id == unit_id) {

                            if(!self.unit_categories[unit.name]){
                                self.unit_categories[unit.name] = {eoi_count: 0};
                            }
                            self.unit_categories[unit.name].bedroom_type = unit.name;
                            self.unit_categories[unit.name].unit_category = unit.category;
                            self.unit_categories[unit.name].eoi_count += 1;
                        }

                    });
                });
            });

            $.each(self.unit_categories, function(index, category){
                self.filtered_categories.push(category);
            });
            
            // self.filtered_categories = self.$filter('orderBy')(self.filtered_categories, "unit_category");
        }
        catch(ex){
            console.log(ex);
        }

    }

    filterAvailableUnits(units) {
        const self = this;

        let statuses = [self.UNIT_STATUS_LISTED, self.UNIT_STATUS_RESERVED, self.UNIT_STATUS_DRAFT];
        let filtered = [];

        _.each(units, function (unit) {
            if (statuses.indexOf(unit.status) !== -1)
                filtered.push(unit);
        });

        if (self.sortBy) {
            filtered = _.sortBy(filtered, function (item) {
                return item[self.sortBy];
            })
        }

        return filtered;
    }

    loadUnits() {
        const self = this;

        self.units = [];

        self.availableUnits = self.SSUtilService.getSortedUnits(self.availableUnits, false, 'named_id');
        self.count = self.availableUnits.length;
        self.pages = Math.ceil(self.count / self.apiLimit);
        self.selectedPage = Math.floor(self.apiOffset / self.apiLimit) + 1;
        self.pagesArr = [];

        for (var i = 0; i < self.pages; i++) {
            self.pagesArr.push(i);
        }
        for (var i = 0; i < self.apiLimit; i++) {
            if (self.apiOffset + i < self.count) {
                self.units.push(self.availableUnits[self.apiOffset + i]);
            }
        }
    }

    pagesGoBack() {
        const self = this;

        self.selectedPage--;
        self.apiOffset = self.apiOffset - self.apiLimit;
        self.loadUnits();
    }

    pagesGoNext() {
        const self = this;

        self.selectedPage++;
        self.apiOffset = self.apiOffset + self.apiLimit;
        self.loadUnits();
    }

    gotoPage(pageNum) {
        const self = this;

        self.apiOffset = parseInt(pageNum) * self.apiLimit;
        self.loadUnits();
    }

    sortData(sortBy) {
        const self = this;

        self.sortBy = sortBy;

        switch (self.sortBy) {
            case "unit_no":
                self.sortByHeading = "#UNIT NO";
                break;
            case "house_no":
                self.sortByHeading = "HOUSE NO";
                break;
            case "name":
                self.sortByHeading = "TYPE";
                break;
            case "price":
                self.sortByHeading = "$PRICE";
                break;
            default:
                self.sortByHeading = "Sort by...";
                break;
        }

        self.processServerData();
    }

    getUnitCellClass(unit) {
        const self = this;

        let cls = '';

        if (!unit.category) {
            cls = 'empty';
        } else if (unit.status == self.UNIT_STATUS_LISTED) {
            if (unit.category in self.UNIT_CATEGORIES_MAP) {
                cls = self.UNIT_CATEGORIES_MAP[unit.category].className;
            } else {
                cls = self.UNIT_CATEGORIES_MAP[0].className;
            }
        } else if (unit.status == self.UNIT_STATUS_SOLD) {
            cls = 'sold';
        } else if (unit.status == self.UNIT_STATUS_DRAFT) {
            cls = 'draft';
            //cls = self.UNIT_CATEGORIES_MAP[3].className;
        } else {
            cls = 'reserved';
        }

        return cls;
    }


    getAllPropertyLaunch(PropertyId, type, LaunchId) {
        const self = this;
        let url = 'sec/developer/properties/' + PropertyId + '/launches';

        let EoiPropertyLaunch = [];

        let params = {
            propertyId: PropertyId
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.registerErrors = self.SSHttpService.parseErrors(response);
                return;
            }
            self.propertyLaunches = response.data.property_launches;

            jQuery.each(self.propertyLaunches, function (i, Eoi) {

                if (EoiPropertyLaunch) {
                    EoiPropertyLaunch = EoiPropertyLaunch.concat(Eoi.id);
                } else {
                    EoiPropertyLaunch = Eoi.id;
                }

            });

            if (EoiPropertyLaunch) {
                self.EoiPropertyLaunchAll = self.getUniqueArray(EoiPropertyLaunch);
            }

            self.getAllEoi(PropertyId, type, LaunchId)
        });

    }

    getAllEoi(PropertyId, type, LaunchId) {
        const self = this;
        let url = 'sec/eois';
        self.registerErrors = null;
        self.first = 1;
        let EoiPropertyLaunch = [];

        let params = {
            property_id: PropertyId,
            include: "brokers, promotion_code",
            limit: 10000
        };


        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.registerErrors = self.SSHttpService.parseErrors(response);
                return;
            }
            self.unitEoi = response.data;

            self.unitEois = response.data;

            // Making changes in Suresh C's code (Comments by Irfan)
            self.all_eois = response.data.eois;

            jQuery.each(self.unitEoi.eois, function (i, Eoi) {

                if (EoiPropertyLaunch) {
                    EoiPropertyLaunch = EoiPropertyLaunch.concat(Eoi.property_launch_id);
                } else {
                    EoiPropertyLaunch = Eoi.property_launch_id;
                }

            });

            if (EoiPropertyLaunch) {
                self.EoiPropertyLaunch = self.getUniqueArray(EoiPropertyLaunch);
            }

            self.getAgenciesByProperty(PropertyId, type, LaunchId)
        });
    }

    gotoEoiPhase(){
        const self = this;

        let url = "/developer/properties/"+self.property_selected+"/eoi-phases/"+ self.launch_id;
        window.location.href = url;
    }

    getUnitsEoi(PropertyId, type, LaunchId, show_loading = true) {
        const self = this;

        self.total_eois_by_phase = 0;
        self.getEBallotingValidation();
        let EoiUnits = null;
        self.property_sid = PropertyId;
        let first = [];
        let EoiPropertyLaunch = [];
        self.EoiUnitsCount = {};
        let Eoibrokers = [];
        let Eoiagencies = [];
        self.unitAgencies = [];
        self.duplicateEoi = [];
        self.duplicateCheque = [];
        let agency = [];

        // if (self.refreshUnits) {
        //     self.$timeout.cancel(self.refreshUnits);
        // }

        if (LaunchId && self.EoiPropertyLaunch.length > 0) {
            self.show_phases = true;
        } else {
            self.show_phases = false;
            return;
        }


        if (jQuery.inArray(parseInt(LaunchId), self.EoiPropertyLaunch) === -1) {
            alert("The selected Launch Id does not have Eoi");
            self.show_phases = false;
            return;
        }


        let url = 'sec/eois';

        if (!PropertyId && self.property) {
            PropertyId = self.property.id;
        }

        self.propertyIdForEoi = PropertyId;
        let params = {
            property_id: PropertyId,
            include: "brokers,promotion_code,sale_status",
            property_launch_id: LaunchId,
            limit: 10000,
            status: "10,11,20,30,60,70,80,90"
        };


        if(show_loading){
            loading(true);
        }

        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.registerErrors = self.SSHttpService.parseErrors(response);
                return;
            }
            self.unitEoiByPhase = response.data;

            self.agencyNames = [];
            self.eoisStatusName = [];
            self.eoisStatusnum = [];

            self.allEoisByPhase = self.unitEoiByPhase.eois;

            jQuery.each(self.unitEoiByPhase.eois, function (i, eoi) {

                if (eoi.calculated_agency_id) {
                    self.agencyNames.push(self.getagencyname(eoi.calculated_agency_id));
                }
                self.eoisStatusName.push(self.getEoiStatusName(eoi.status));
                self.eoisStatusnum.push(eoi.status);
            });

            self.agencyNames = self.getUniqueArray(self.agencyNames);
            self.eoisStatusName = self.getUniqueArray(self.eoisStatusName);
            self.eoisStatusnum = self.getUniqueArray(self.eoisStatusnum);


            self.filterEoiByCategory(LaunchId, type);


            // jQuery.each(self.unitEoi.eois, function (i, Eoi) {
            //   console.log(Eoi.units);
            //  first=Eoi.units.replace(/[\[\]']+/g,'');
            //  first=first.split(",").map(Number);
            //  Eoi.units= "[["+first[0]+"]]";

            // });


            // get the Eoi Details
            jQuery.each(self.unitEoiByPhase.eois, function (i, Eoi) {

                if (Eoi.property_launch_id == LaunchId) {

                    self.total_eois_by_phase += 1;
                    
                    jQuery.each(Eoi.brokers, function (i, broker) {


                        jQuery.each(self.unitEoiByPhase.brokers, function (i, brokerId) {

                            if (broker.broker_user_id == brokerId.user_id) {
                                broker.agency_id_found = brokerId.agency_id;
                                return false;
                            }
                        });


                        if (self.propertyAgency.property_agencies.find(x => x.agency_id === broker.agency_id_found)) {
                            Eoibrokers.push({
                                'broker_user_id': broker.broker_user_id,
                                'eoi': Eoi
                            });
                            return false;
                        }

                    });

                    let eoiUnitsChoices = [];
                    try {
                        eoiUnitsChoices = JSON.parse(Eoi.units); // [[201,202,205],[203,201]]
                    } catch(ex){
                    }

                    $.each(eoiUnitsChoices, function(i, _eoiUnitChoices) {
                        $.each(_eoiUnitChoices, function(j, _unitId) {
                            if (type == 2 && j == 0) { // First Choice
                                EoiUnits = EoiUnits ? (EoiUnits + ',' + _unitId) : _unitId;
                            } else if (type == 1) { // All Choices
                                EoiUnits = EoiUnits ? (EoiUnits + ',' + _unitId) : _unitId;
                            }
                        });
                    });
                }


                if (EoiPropertyLaunch) {
                    EoiPropertyLaunch = EoiPropertyLaunch.concat(Eoi.property_launch_id);
                } else {
                    EoiPropertyLaunch = Eoi.property_launch_id;
                }

            });


            // jQuery.each(self.unitEoiByPhase.agencyFound, function (i, Agency) {
            //         self.duplicateEoi.push({agencyName:self.getagencyname(i), agencyCount:Agency});
            // });
            //
            // jQuery.each(self.unitEoiByPhase.runningCheques, function (i, Agency) {
            //     self.duplicateCheque.push({agencyName:self.getagencyname(i), agencyCount:Agency.length});
            // });

            //get the agency details
            jQuery.each(Eoibrokers, function (i, broker) {

                jQuery.each(self.unitEoiByPhase.brokers, function (i, eoi_broker) {

                    if (broker.broker_user_id == eoi_broker.user_id) {
                        Eoiagencies.push({'agency_id': eoi_broker.agency_id, 'eoi': broker.eoi});
                    }
                });

            });

            if (EoiUnits && (EoiUnits.toString().indexOf(',') > -1)) {
                self.EoiUnits = EoiUnits.split(",").map(Number);
            } else {
                self.EoiUnits = jQuery.makeArray(EoiUnits);
            }

            self.EoiUnitsCount = self.EoiUnits.reduce(function (acc, curr) {
                if (typeof acc[curr] == 'undefined') {
                    acc[curr] = 1;
                } else {
                    acc[curr] += 1;
                }

                return acc;
            }, {});

            // self.EoiAgencyCount = Eoiagencies.reduce(function (acc, curr) {
            //     if (typeof acc[curr.agency_id] == 'undefined') {
            //         acc[curr.agency_id] = 1;
            //     } else {
            //         acc[curr.agency_id] += 1;
            //     }

            //     return acc;
            // }, {});

            self.EoiAgencyCount = {};
            var verified_eoi_count = 0;
            var registered_eoi_count = 0;
            var completed_eoi_count = 0;
            var balloted_eoi_count = 0;
            var unit_allocated_eoi_count = 0;
            // var verified_sales_count = 0;
            var completed_eois_count = 0;
            var total = 0;

            $.each(Eoiagencies, function (index, agency) {

                if (typeof self.EoiAgencyCount[agency.agency_id] == 'undefined') {
                    self.EoiAgencyCount[agency.agency_id] = {
                        'total': 1,
                        'verified_eoi_count': self.isVerifiedEoi(agency.eoi) ? 1 : 0,
                        'registered_eoi_count': self.isRegisteredEoi(agency.eoi) ? 1 : 0,
                        'completed_eoi_count': self.isCompletedEoi(agency.eoi) ? 1 : 0,
                        'balloted_eoi_count': self.isBallotedEoi(agency.eoi) ? 1 : 0,
                        'unit_allocated_eoi_count': self.isUnitAllocatedEoi(agency.eoi) ? 1 : 0,
                        // 'verified_sales_count': self.isVerifiedSale(agency.eoi) ? 1 : 0,
                        'completed_eois_count': self.isCompletedEoi(agency.eoi) ? 1 : 0,
                    };
                } else {
                    total = (self.EoiAgencyCount[agency.agency_id].total += 1);

                    verified_eoi_count = self.isVerifiedEoi(agency.eoi) ? (self.EoiAgencyCount[agency.agency_id].verified_eoi_count += 1) : self.EoiAgencyCount[agency.agency_id].verified_eoi_count;
                    registered_eoi_count = self.isRegisteredEoi(agency.eoi) ? (self.EoiAgencyCount[agency.agency_id].registered_eoi_count += 1) : self.EoiAgencyCount[agency.agency_id].registered_eoi_count;
                    completed_eoi_count = self.isCompletedEoi(agency.eoi) ? (self.EoiAgencyCount[agency.agency_id].completed_eoi_count += 1) : self.EoiAgencyCount[agency.agency_id].completed_eoi_count;
                    balloted_eoi_count = self.isBallotedEoi(agency.eoi) ? (self.EoiAgencyCount[agency.agency_id].balloted_eoi_count += 1) : self.EoiAgencyCount[agency.agency_id].balloted_eoi_count;
                    unit_allocated_eoi_count = self.isUnitAllocatedEoi(agency.eoi) ? (self.EoiAgencyCount[agency.agency_id].unit_allocated_eoi_count += 1) : self.EoiAgencyCount[agency.agency_id].unit_allocated_eoi_count;
                    // verified_sales_count = self.isVerifiedSale(agency.eoi) ? (self.EoiAgencyCount[agency.agency_id].verified_sales_count += 1) : self.EoiAgencyCount[agency.agency_id].verified_sales_count;
                    completed_eois_count = self.isCompletedEoi(agency.eoi) ? (self.EoiAgencyCount[agency.agency_id].completed_eois_count += 1) : self.EoiAgencyCount[agency.agency_id].completed_eois_count;

                    self.EoiAgencyCount[agency.agency_id] = {
                        'total': total,
                        'verified_eoi_count': verified_eoi_count,
                        'registered_eoi_count': registered_eoi_count,
                        'completed_eoi_count': completed_eoi_count,
                        'balloted_eoi_count': balloted_eoi_count,
                        'unit_allocated_eoi_count': unit_allocated_eoi_count,
                        // 'verified_sales_count': verified_sales_count,
                        'completed_eois_count': completed_eois_count,
                    };
                }
            });

            jQuery.each(self.EoiAgencyCount, function (i, agencies) {

                agency = {};
                agency.name = self.getagencyname(i);
                agency.count = agencies.total;

                agency.verified_eois = agencies.verified_eoi_count;
                agency.registered_eois = agencies.registered_eoi_count;
                agency.completed_eois = agencies.completed_eoi_count;
                agency.balloted_eois = agencies.balloted_eoi_count;
                agency.unit_allocated_eois = agencies.unit_allocated_eoi_count;
                // agency.verified_sales = agencies.verified_sales_count;
                agency.completed_eois = agencies.completed_eois_count;

                self.unitAgencies.push(agency);
            });

            self.all_agencies_total_eois = 0;
            self.all_agencies_verified_eois = 0;
            self.all_agencies_registered_eois = 0;
            self.all_agencies_balloted_eois = 0;
            self.all_agencies_unit_allocated_eois = 0;
            self.all_agencies_completed_eois = 0;

            // Calculate total count against each agency
            $.each(self.unitAgencies, function (index, obj) {
                self.all_agencies_total_eois += obj.count;
                self.all_agencies_verified_eois += obj.verified_eois;
                self.all_agencies_registered_eois += obj.registered_eois;
                self.all_agencies_balloted_eois += obj.balloted_eois;
                self.all_agencies_unit_allocated_eois += obj.unit_allocated_eois;
                self.all_agencies_completed_eois += obj.completed_eois;
            });

            self.getEoiByCategory(1);

        });

        // Temp disabling of auto refresh
        // Auto refresh
        // self.refreshUnits = self.$timeout(function() {
        //   self.getUnitsEoi(PropertyId, type, LaunchId, false);
        // }, self.AUTO_REFRESH_TIME? self.AUTO_REFRESH_TIME : 10*1000);
    }

    isVerifiedEoi(eoi) {
        const self = this;

        if (!eoi) {
            return false;
        }

        if (eoi.status == self.EOI_STATUS_VERIFIED
            || eoi.status == self.EOI_STATUS_REGISTERED
            || eoi.status == self.EOI_STATUS_SUCCESSFUL
            || eoi.status == self.EOI_STATUS_UNSUCCESSFUL
            || eoi.status == self.EOI_STATUS_COMPLETED) {
            return true;
        } else {
            return false;
        }
    }

    isRegisteredEoi(eoi) {
        const self = this;

        if (!eoi) {
            return false;
        }

        if (eoi.status == self.EOI_STATUS_REGISTERED
            || eoi.status == self.EOI_STATUS_SUCCESSFUL
            || eoi.status == self.EOI_STATUS_UNSUCCESSFUL
            || eoi.status == self.EOI_STATUS_COMPLETED) {
            return true;
        } else {
            return false;
        }
    }

    isCompletedEoi(eoi) {
        const self = this;

        if (!eoi) {
            return false;
        }

        if (eoi.status == self.EOI_STATUS_COMPLETED) {
            return true;
        } else {
            return false;
        }
    }

    isBallotedEoi(eoi) {
        const self = this;

        if (!eoi) {
            return false;
        }

        if ((eoi.status == self.EOI_STATUS_VERIFIED 
            || eoi.status == self.EOI_STATUS_REGISTERED
            || eoi.status == self.EOI_STATUS_SUCCESSFUL
            || eoi.status == self.EOI_STATUS_UNSUCCESSFUL
            || eoi.status == self.EOI_STATUS_COMPLETED) && eoi.queue_no != null) {
            return true;
        } else {
            return false;
        }
    }

    isUnitAllocatedEoi(eoi) {
        const self = this;

        if (!eoi) {
            return false;
        }

        if (eoi.status == self.EOI_STATUS_SUCCESSFUL) {
            return true;
        } else {
            return false;
        }
    }

    isCompletedEoi(eoi) {
        const self = this;

        if (!eoi) {
            return false;
        }

        if (eoi.status == self.EOI_STATUS_COMPLETED) {
            return true;
        } else {
            return false;
        }
    }

    getUnitsPhase(unitId) {

        const self = this;
        let phase_class = null;


        if (self.phase_master) {
            if (typeof self.getHeapMapClass_count(unitId, null) == "undefined") {
                jQuery.each(self.phase_master.property_launches, function (i, phase) {


                    if (phase.units) {
                        if (jQuery.inArray(unitId, phase.units) !== -1) {
                            phase_class = "phase";
                            return false;
                        }
                    }
                });
                return phase_class;
            }
        }

    }

    getAgencyByUnit(unitId, type, LaunchId) {
        const self = this;

        let EoiUnits = null;
        let output = "";
        let Eoibrokers = [];
        let Eoiagencies = [];
        let agency = [];
        self.unitAgencies_unit = [];
        self.unitAgencies_change = [];
        self.EoiAgencyCount_unit = {};

        jQuery.each(self.unitEoiByPhase.eois, function (i, Eoi) {

            if (Eoi.property_launch_id == LaunchId) {

                if (Eoi.units) {
                    try{
                        // Eoi.Units = '[[32570,32615],[7001,6005]]'
                        EoiUnits = JSON.parse(Eoi.units);
                    } catch(ex) {}
                }

                if (type === 2) {

                    jQuery.each(EoiUnits, function (i, choices) {

                        if (unitId == choices[0]) {

                            jQuery.each(Eoi.brokers, function (j, broker) {

                                if (self.propertyAgency.property_agencies.find(x => x.agency_id === broker.agency_id_found)) {
                                    Eoibrokers.push(broker.broker_user_id);
                                    return false;
                                }

                            });
                            return false;
                        }
                    });
                } else {
                    let unitChoices = EoiUnits;

                    $.each(unitChoices, function(j, choices){
                        if (jQuery.inArray(unitId, choices) !== -1) {

                            jQuery.each(Eoi.brokers, function (i, broker) {

                                if (self.propertyAgency.property_agencies.find(x => x.agency_id === broker.agency_id_found)) {
                                    Eoibrokers.push(broker.broker_user_id);
                                    return false;
                                }
                            });
                        }
                    });
                }
            }
        });

        jQuery.each(Eoibrokers, function (i, broker) {
            jQuery.each(self.unitEoiByPhase.brokers, function (i, brokerId) {
                if (broker == brokerId.user_id) {

                    if (brokerId.agency_id != '') {
                        Eoiagencies.push(brokerId.agency_id);
                    }
                }
            });
        });

        self.EoiAgencyCount_unit = Eoiagencies.reduce(function (acc, curr) {
            if (typeof acc[curr] == 'undefined') {
                acc[curr] = 1;
            } else {
                acc[curr] += 1;
            }

            return acc;
        }, {});

        jQuery.each(self.EoiAgencyCount_unit, function (i, agencies) {
            agency = {};
            agency.name = self.getagencyname(i);
            agency.count = agencies;
            self.unitAgencies_unit.push(agency);
        });

        jQuery.each(self.unitAgencies_unit, function (i, agn) {
            if (output == '') {
                output = "<p><strong>" + agn.name + "<span>" + agn.count + "</span></strong></p>";
            } else {
                output += "<p><strong>" + agn.name + "<span>" + agn.count + "</span></strong></p>";
            }
        });

        if (output != null) {
            document.getElementById(unitId).innerHTML = output;
        }

    }

    getagencyname(agencyId) {
        const self = this;
        let agencyname = null;

        jQuery.each(self.unitEoiByPhase.agencies, function (i, agencies) {

            if (agencies.id == agencyId) {
                agencyname = agencies.name;
                return false;
            }
        });

        return agencyname;
    }

    getAgencyName(agencyId) {
        const self = this;
        if (agencyId == null || agencyId == '' || agencyId == undefined)
            return '';
        let agencyname = '';

        jQuery.each(self.unitEoiByPhase.agencies, function (i, agencies) {

            if (agencies.id == agencyId) {
                agencyname = agencies.name;
                return false;
            }
        });

        return agencyname;
    }


    propertyLaunchName(launchId) {
        const self = this;
        if (self.phase) {
            jQuery.each(self.phase.property_launches, function (i, launch) {

                if (launch.id) {

                    if (launch.id == launchId) {
                        name = launch.name;
                    }
                }
            });
        }

        return name;
    }

    updatePhaseSelection(LaunchId) {
        const self = this;

        let Eoiagencies = [];
        let Eoibrokers = [];
        let agency = [];
        self.unitAgencies = [];

        let EoiUnits = null;
        if (LaunchId && self.EoiPropertyLaunch.length > 0) {
            self.show_phases = true;
        } else {
            self.show_phases = false;
        }


        if (LaunchId != "all") {
            jQuery.each(self.unitEoi, function (i, Eois) {
                jQuery.each(Eois, function (i, Eoi) {

                    if (Eoi.property_launch_id == LaunchId) {
                        jQuery.each(Eoi.brokers, function (i, broker) {

                            if (broker.broker_role == '1') {
                                Eoibrokers.push(broker.broker_user_id);
                                return false;
                            }

                        });

                        if (EoiUnits) {
                            EoiUnits = EoiUnits.concat(',' + Eoi.units.replace(/[\[\]']+/g, ''));

                        } else {
                            EoiUnits = Eoi.units.replace(/[\[\]']+/g, '');

                        }

                        if (EoiPropertyLaunch) {
                            // EoiPropertyLaunch=EoiPropertyLaunch.concat(Eoi.property_launch_id);
                        } else {
                            // EoiPropertyLaunch=Eoi.property_launch_id;
                        }
                    }

                });
            });

            //get the agency details
            jQuery.each(Eoibrokers, function (i, broker) {

                jQuery.each(self.unitEoi.brokers, function (i, brokerId) {

                    if (broker == brokerId.user_id) {
                        Eoiagencies.push(brokerId.agency_id);
                    }
                });

            });

            jQuery.each(self.phase.property_launches, function (i, phase) {

                if (LaunchId == phase.id) {
                    self.phase_master.property_launches = [];
                    self.phase_master.property_launches[0] = phase;
                    return false;
                }

            });


            // console.log(self.phase_master.property_launches);


        } else {
            jQuery.each(self.unitEoi, function (i, Eois) {
                jQuery.each(Eois, function (i, Eoi) {

                    // console.log(Eoi);

                    if (Eoi.units) {
                        if (EoiUnits) {
                            EoiUnits = EoiUnits.concat(',' + Eoi.units.replace(/[\[\]']+/g, ''));

                        } else {
                            EoiUnits = Eoi.units.replace(/[\[\]']+/g, '');

                        }

                        if (EoiPropertyLaunch) {
                            // EoiPropertyLaunch=EoiPropertyLaunch.concat(Eoi.property_launch_id);
                        } else {
                            // EoiPropertyLaunch=Eoi.property_launch_id;
                        }
                    }


                });
            });

            self.phase_master.property_launches = {};

            jQuery.each(self.phase.property_launches, function (i, phase) {


                self.phase_master.property_launches[i] = phase;


            });
        }
        // console.log(self.phase_master.property_launches);

        if (EoiUnits) {
            self.EoiUnits = EoiUnits.split(",").map(Number);
        }


        self.EoiUnitsCount = self.EoiUnits.reduce(function (acc, curr) {
            if (typeof acc[curr] == 'undefined') {
                acc[curr] = 1;
            } else {
                acc[curr] += 1;
            }

            return acc;
        }, {});


        self.EoiAgencyCount = Eoiagencies.reduce(function (acc, curr) {
            if (typeof acc[curr] == 'undefined') {
                acc[curr] = 1;
            } else {
                acc[curr] += 1;
            }

            return acc;
        }, {});

        jQuery.each(self.EoiAgencyCount, function (i, agencies) {
            agency = {};
            agency.name = self.getagencyname(i);
            agency.count = agencies;
            self.unitAgencies.push(agency);
        });

        self.getEoiByCategory(1);

    }


    getUniqueArray(array) {
        var result = [];
        for (var x = 0; x < array.length; x++) {
            if (result.indexOf(array[x]) == -1)
                result.push(array[x]);
        }
        return result;
    }

    /**
     * WEB-4720: EOI count numbers on this page are shown only with DMS_VW_EOI_COUNT on the
     * selected project (strictly per project, as the API checks it). Heat colours are not affected.
     */
    canViewEoiCount() {
        const self = this;
        const propertyId = self.property ? self.property.id : null;

        return self.SSUserService.hasPermissionForProperty('DMS_VW_EOI_COUNT', propertyId);
    }

    getHeapMapClass(unitId, unit) {
        const self = this;

        if (jQuery.inArray(unitId, self.EoiUnits) !== -1) {

            var count = self.EoiUnitsCount[unitId];

            if (count > 0 && count < 2) {
                var className = "db-cyan";
            } else if (count > 1 && count < 3) {
                className = "db-lt-blue";
            } else if (count < 1) {
                className = "legend-color db-lt-gray";
            } else if (count > 2 && count <= 4) {
                className = "legend-color db-blue";
            } else if (count > 4 && count <= 6) {
                className = "legend-color db-light-navy";
            } else if (count > 6 && count <= 8) {
                className = "legend-color db-dark-navy";
            } else if (count >= 9) {
                className = "legend-color db-darker-navy";
            } else {
                className = "db-lt-gray";
            }

            return className;
        } else {

            return "db-lt-gray";
        }
    }

    getHeapMapClass_count(unitId, unit) {
        const self = this;
        if (self.EoiUnitsCount) {
            return self.EoiUnitsCount[unitId];
        }
    }


    getEoiCountByUnit(unitId) {

        const self = this;

        if (unitId) {
            var count = self.EoiUnitsCount[unitId];
            return count;
        }
    }


    showUnits(x) {

        const self = this;


        self.selectedPropertyLaunch = x;

        if (x && self.click_phaseCount == 0) {
            jQuery.each(self.stacks, function (i, stacks) {
                jQuery.each(stacks.availableUnits, function (j, unit_data) {
                    //

                    if (jQuery.inArray(unit_data.id, x.units) !== -1) {
                        //             //console.log(unit_data.id+"iid");

                        unit_data.clickedclass = true;
                        unit_data.selection = "selected";
                        //
                        //             // if(self.selected_units_phase!=null) {
                        //             //self.selected_units_phase =  self.selected_units_phase + ',' +unit_data.id ;
                        //             // }
                        //             // else{
                        //             //   self.selected_units_phase = unit_data.id;
                        //             // }
                    }
                    //
                });
                //
            });
        }
        //
        self.phase_container = true;
        self.edited_unit = x;
    }

    clearSelection() {
        const self = this;
        jQuery.each(self.stacks, function (i, stacks) {
            jQuery.each(stacks.availableUnits, function (j, unit_data) {
                //
                unit_data.clickedclass = false;
                unit_data.selection = "unselected";
                //
            });
            //
        });
    }

    toggle_all_unit(x, stack) {
        const self = this;

        if (self.select_all_unit[stack.id]) {
            jQuery.each(self.stacks, function (i, stacks) {
                if (stacks.id == stack.id) {
                    jQuery.each(stacks.availableUnits, function (j, unit_data) {
                        if (unit_data.status != self.UNIT_STATUS_RESERVED) {
                            unit_data.clickedclass = true;
                            unit_data.selection = "selected";
                        }
                    });
                }
            });

        } else {
            if (x) {
                jQuery.each(self.stacks, function (i, stacks) {
                    if (stacks.id == stack.id) {
                        jQuery.each(stacks.availableUnits, function (j, unit_data) {
                            //

                            //  if (jQuery.inArray(unit_data.id, x.units) !== -1) {
                            //   unit_data.clickedclass = true;
                            //  unit_data.selection = "selected";
                            //  }
                            //  else {
                            unit_data.clickedclass = false;
                            unit_data.selection = "unselected";
                            //  }
                            //   console.log(unit_data.clickedclass);
                            //
                        });
                    }
                });
            } else {
                jQuery.each(self.stacks, function (i, stacks) {
                    if (stacks.id == stack.id) {
                        jQuery.each(stacks.availableUnits, function (j, unit_data) {
                            unit_data.clickedclass = false;
                            unit_data.selection = "unselected";
                        });
                    }
                });
            }
            //
            self.phase_container = true;
            self.edited_unit = x;

        }
    }

    isSelected(unitId) {
        const self = this;

        if (self.selectedPropertyLaunch) {
            return jQuery.inArray(unitId, self.selectedPropertyLaunch.units) >= 0;
        }
    }

    postSelection(add_phase) {

        const self = this;
        self.phase_container = false;
        self.selected_units_phase = null;
        self.post_selected++;


        jQuery.each(self.phase.property_launches, function (i, phase) {

            phase.currentSelection = true;

        });

        if (self.edited_unit) {
            self.edited_unit.currentSelection = false;
        }
        self.selected_units = self.stacks;


        jQuery.each(self.stacks, function (i, stacks) {
            jQuery.each(stacks.availableUnits, function (j, unit_data) {

                if (unit_data.clickedclass & unit_data.clickedclass == true) {


                    if (self.selected_units_phase != null) {
                        self.selected_units_phase = self.selected_units_phase + ',' + unit_data.id;


                    } else {
                        self.selected_units_phase = unit_data.id;


                    }

                }

            });

        });


        if (self.edited_unit) {
            // self.edited_unit.units = self.selected_units_phase;
            self.edited_unit.selectedUnits = self.selected_units_phase;

        } else {
            self.new_selected_units = self.selected_units_phase;
        }


        if (self.edited_unit) {
            self.edited_unit.updated_units = self.selected_units_phase_arr;
        }

        if (!add_phase) {
            self.updatePhase(self.edited_phase);
        } else {
            self.savePhase(self.propertyLaunch, self.propertys_id);
        }
    }

    unitsSelected() {

        const self = this;
        //  self.phase_container=false;
        self.selected_units_phase = null;
        self.post_selected++;
        //self.unitrequest = {};

        if (!self.phase)
            return;

        jQuery.each(self.phase.property_launches, function (i, phase) {

            phase.currentSelection = true;

        });

        if (self.edited_unit) {
            self.edited_unit.currentSelection = false;
        }
        self.selected_units = self.stacks;


        jQuery.each(self.stacks_promocodes, function (i, stacks) {
            jQuery.each(stacks.availableUnits, function (j, unit_data) {

                if (unit_data.clickedclass & unit_data.clickedclass == true) {


                    if (self.selected_units_phase != null) {
                        self.selected_units_phase = self.selected_units_phase + ',' + unit_data.id;


                    } else {
                        self.selected_units_phase = unit_data.id;


                    }

                }

            });

        });

        // if(self.edited_unit) {
        //     // self.edited_unit.units = self.selected_units_phase;
        //     self.edited_unit.selectedUnits = self.selected_units_phase;
        //
        // }
        // else {
        self.new_selected_units = self.selected_units_phase;
        // }

        //  self.edited_unit.updated_units=self.selected_units_phase_arr;

        if (!self.new_selected_units)
            return;

        self.unitrequest.unit_ids = self.new_selected_units.toString().split(',');

        self.generate();
    }

    generate() {
        const self = this;
        var request = {};


        if (!self.validateGenerateParams2()) return;
        self.unitrequest.property_id = self.data.property_id;
        request = self.unitrequest;

        loading(true);
        self.SSHttpService.postAPIRequest(`sec/developer/promotion-codes/generate`, request).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSUtilService.logError(response);
                self.error = 'Something went wrong. Please retry.';
                return;
            }
            self.parseAndPush(response.data.promotion_codes);
            self.unitrequest = null;
            self.SSAlertService.success("Success!", "Promotion code created successfully");
        });
    }


    parseAndPush(promotion_codes) {
        const self = this;

        if (!self.data.promotion_codes) {
            self.data.promotion_codes = {};
        }

        $.each(promotion_codes, function (i, promotion_code) {
            let property_id = promotion_code.property_id;
            if (!(property_id in self.data.promotion_codes)) {
                self.data.promotion_codes[property_id] = {};
            }
            if (promotion_code.unit_types) {
                let unit_types = promotion_code.unit_types.split(',');

                $.each(unit_types, function (j, unit_type) {
                    if (!(unit_type in self.data.promotion_codes[property_id])) {
                        self.data.promotion_codes[property_id][unit_type] = [];
                    }
                    self.data.promotion_codes[property_id][unit_type].push(promotion_code);
                });
            }
            if (promotion_code.unit_ids) {
                let unit_ids = promotion_code.unit_ids.split(',');

                $.each(unit_ids, function (j, unit_id) {
                    if (!(unit_id in self.data.promotion_codes[property_id])) {
                        self.data.promotion_codes[property_id][unit_id] = [];
                    }
                    self.data.promotion_codes[property_id][unit_id].push(promotion_code);
                });
            }
        });
    }

    validateGenerateParams() {
        const self = this;

        if (!self.request.property_id || !self.request.unit_types || !self.request.discount_type || !self.request.discount_value || !self.request.count || !self.request.available_from_d || !self.request.available_to_d) {
            self.error = 'Please fill required values.';
            return;
        }
        if (self.request.count < 1 || self.request.count > 100) {
            self.request.count = 0;
            self.error = 'The number of codes to generate should be between 1 and 100.';
            return;
        }
        if (self.request.discount_type == self.DISCOUNT_TYPE.PERCENTAGE) {
            if (self.request.discount_value < 1 || self.request.discount_value > 100) {
                self.request.discount_value = 0;
                self.error = 'The percentage discount value should be between 1 and 100.';
                return;
            }
        }

        let minDate = new Date();
        minDate.setHours(0, 0, 0, 0);

        let maxDate = new Date();
        maxDate.setHours(0, 0, 0, 0);
        maxDate.setDate(maxDate.getDate() + 7);

        self.request.available_from = self.dateToString(self.request.available_from_d);
        self.request.available_to = self.dateToString(self.request.available_to_d);

        // if (self.request.available_from > self.request.available_to) {
        //     self.error2 = 'The To date date must be a after From date.';
        //     return;
        // }

        self.error = '';
        return true;
    }

    validateGenerateParams2() {
        const self = this;

        if (!self.unitrequest.discount_type || !self.unitrequest.discount_value || !self.unitrequest.count || !self.unitrequest.available_from_d || !self.unitrequest.available_to_d) {
            self.error2 = 'Please fill required values.';
            return;
        }
        if (self.unitrequest.count < 1 || self.unitrequest.count > 100) {
            self.unitrequest.count = 0;
            self.error2 = 'The number of codes to generate should be between 1 and 100.';
            return;
        }
        if (self.unitrequest.discount_type == self.DISCOUNT_TYPE.PERCENTAGE) {
            if (self.unitrequest.discount_value < 1 || self.unitrequest.discount_value > 100) {
                self.unitrequest.discount_value = 0;
                self.error2 = 'The percentage discount value should be between 1 and 100.';
                return;
            }
        }

        let minDate = new Date();
        minDate.setHours(0, 0, 0, 0);

        let maxDate = new Date();
        maxDate.setHours(0, 0, 0, 0);
        maxDate.setDate(maxDate.getDate() + 7);

        self.unitrequest.available_from = self.dateToString(self.unitrequest.available_from_d);
        self.unitrequest.available_to = self.dateToString(self.unitrequest.available_to_d);

        self.error2 = '';

        return true;
    }

    cancelSelection(x) {

        const self = this;
        console.log(x);
        console.log(self.stacks);

        self.phase_container = false;
        self.selected_units_phase = null;
        self.select_all_unit = false;

        jQuery.each(self.phase.property_launches, function (i, phase) {

            phase.currentSelection = true;

        });

        if (self.edited_unit) {
            self.edited_unit.currentSelection = false;
        }
        // self.selected_units = self.stacks;
        if (x) {
            jQuery.each(self.stacks, function (i, stacks) {
                jQuery.each(stacks.availableUnits, function (j, unit_data) {
                    //

                    if (jQuery.inArray(unit_data.id, x.units) !== -1) {
                        unit_data.clickedclass = true;
                        unit_data.selection = "selected";
                    } else {
                        unit_data.clickedclass = false;
                        unit_data.selection = "unselected";
                    }
                    console.log(unit_data.clickedclass);
                    //
                });
                //
            });
        } else {
            jQuery.each(self.stacks, function (i, stacks) {
                jQuery.each(stacks.availableUnits, function (j, unit_data) {
                    //
                    unit_data.clickedclass = false;
                    unit_data.selection = "unselected";
                    //
                });
                //
            });

        }


        jQuery.each(self.stacks, function (i, stacks) {
            jQuery.each(stacks.availableUnits, function (j, unit_data) {

                if (unit_data.clickedclass & unit_data.clickedclass == true) {


                    if (self.selected_units_phase != null) {
                        self.selected_units_phase = self.selected_units_phase + ',' + unit_data.id;


                    } else {
                        self.selected_units_phase = unit_data.id;


                    }

                }

            });

        });


        if (self.edited_unit) {
            // self.edited_unit.units = self.selected_units_phase;
            self.edited_unit.selectedUnits = self.selected_units_phase;

        } else {
            self.new_selected_units = self.selected_units_phase;
        }

        if (self.edited_unit) {
            self.edited_unit.updated_units = self.selected_units_phase_arr;
        }
    }

    checkArray(propertyLaunch) {
        const self = this;

        if (propertyLaunch == null || propertyLaunch == undefined || propertyLaunch == "" || propertyLaunch == 0)
            return;

        if ((!propertyLaunch.selectedUnits && parseInt(self.post_selected) === 1) || (!propertyLaunch.selectedUnits && parseInt(self.post_selected) === 0)) {

            if (propertyLaunch.units instanceof Array) {

                return propertyLaunch.units.length;

            } else {
                propertyLaunch.units = propertyLaunch.units.split(",");
                var length = (propertyLaunch.units.length);
                return length;
            }
        } else {

            if (propertyLaunch.selectedUnits instanceof Array) {
                return propertyLaunch.selectedUnits.length;
            } else {
                if (propertyLaunch.selectedUnits) {
                    propertyLaunch.selectedUnits = propertyLaunch.selectedUnits.split(",");
                    var length = (propertyLaunch.selectedUnits.length);
                    return length;
                }
                return;
            }
        }


    }

    checkArrayDup(propertyLaunch) {
        const self = this;

        if (propertyLaunch == null || propertyLaunch == undefined || propertyLaunch == "" || propertyLaunch == 0)
            return;

        if ((!propertyLaunch.selectedUnits && parseInt(self.post_selected) === 1) || (!propertyLaunch.selectedUnits && parseInt(self.post_selected) === 0)) {

            if (propertyLaunch.units instanceof Array) {

                return propertyLaunch.units.length;

            } else {
                propertyLaunch.units = propertyLaunch.units.split(",");
                var length = (propertyLaunch.units.length);
                return length;
            }
        } else {

            if (propertyLaunch.selectedUnits instanceof Array) {
                return propertyLaunch.selectedUnits.length;
            } else {
                if (propertyLaunch.selectedUnits) {
                    propertyLaunch.selectedUnits = propertyLaunch.selectedUnits.split(",");
                    var length = (propertyLaunch.selectedUnits.length);
                    return length;
                }
                return;
            }
        }


    }

    checkArr(units) {

        if (units) {
            if (units instanceof Array) {
                return units.length;
            } else {
                units = units.split(",")
                return units.length;
            }
        }
    }

    toggle_Unit_selection(unit) {
        const self = this;

        unit.clickedclass = unit.clickedclass ? false : true;

        if (unit.clickedclass) {
            unit.selection = 'selected';
        } else {
            unit.selection = 'unselected';
        }

    }

    viewUnit(unit) {
        const self = this;

        window.location.href = '/' + self.property.named_id + '/' + unit.named_id;
    }

    filterViewStack(className) {
        const self = this;

        var buttons = $("div.scroll").find("button");

        self.selected_class_name = className;

        //Make all visible
        var invisible_buttons = $("div.scroll").find("button.greyout");
        jQuery.each(invisible_buttons, function (i, button) {
            $(button).removeClass("greyout");
        });

        //Make all invisible other than className
        if (className) {
            jQuery.each(buttons, function (i, button) {
                if (!$(button).hasClass(className)) {
                    $(button).addClass("greyout");
                }
            });
        }
    }

    filterViewStackPromoCode(className) {
        var buttons = $("div.scroll_promo_code").find("button");

        //Make all visible
        var invisible_buttons = $("div.scroll_promo_code").find("button.greyout");
        jQuery.each(invisible_buttons, function (i, button) {
            $(button).removeClass("greyout");
        });

        //Make all invisible other than className
        if (className) {
            jQuery.each(buttons, function (i, button) {
                if (!$(button).hasClass(className)) {
                    $(button).addClass("greyout");
                }
            });
        }
    }

    dateToString(d) {
        const self = this;
        if (!d) return;

        var split_date = d.split(" ", 2);
        var res = split_date[0].split("/", 3);
        var date_converted = res[2] + '-' + res[1] + '-' + res[0] + ' ' + split_date[1];

        if (date_converted) {
            var date_converted_to = new Date(self.parseDate(date_converted + ':00'));
            // var start_utcFormat = moment(start_localDate).utc().format('YYYY-MM-DD HH:mm:ss');
        }
        return date_converted_to;

    }

    filterLegendEoi(className) {
        var buttons = $("div.dashboard-scroll").find("button");

        //Make all visible
        var invisible_buttons = $("div.dashboard-scroll").find("button.greyout");
        jQuery.each(invisible_buttons, function (i, button) {
            $(button).removeClass("greyout");
        });

        //Make all invisible other than className
        if (className) {
            jQuery.each(buttons, function (i, button) {
                if (!$(button).hasClass(className)) {
                    $(button).addClass("greyout");
                }
            });
        }
    }

    get360photoClass(unit) {
        if (unit.floor_plan_3d != null) {
            return '360photo';
        }
    }

    get3DFloorPlanClass(unit) {
        if (unit.floor_plan_3d != null) {
            return '3Dfloorplan';
        }
    }

    getPaymentPlans() {
        const self = this;

        let url = 'sec/developer/properties/' + self.property.id + '/payment-plans';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data.payment_plans && response.data.payment_plans.length > 0) {
                self.can_add_phase = true;
            } else {
                self.can_add_phase = false;
            }
        });
    }

    searchByAgencyName(searchEoiAgency) {
        const self = this;

        // let eoisByPhase = self.allEoisByPhase;

        if (searchEoiAgency == null) {
            self.allEoisByPhase = self.unitEoiByPhase.eois;
        } else {
            self.allEoisByPhase = [];
            jQuery.each(self.unitEoiByPhase.eois, function (i, eoi) {
                if (eoi.calculated_agency_id) {

                    if (self.getagencyname(eoi.calculated_agency_id) == searchEoiAgency){
                        self.allEoisByPhase.push(eoi);
                    }
                }
            });
        }
    }

    searchByStatus(searchEoiStatus) {
        const self = this;

        // let eoisByPhase = self.allEoisByPhase;

        if (searchEoiStatus == null || searchEoiStatus == '') {
            self.allEoisByPhase = self.unitEoiByPhase.eois;
        } else {
            self.allEoisByPhase = [];
            jQuery.each(self.unitEoiByPhase.eois, function (i, eoi) {
                if (self.getEoiStatusName(eoi.status) == searchEoiStatus){
                    self.allEoisByPhase.push(eoi);
                }
            });
        }
    }

    initEOisStatuses(){
        const self = this;

        self.EOIS_STATUSES = [
            {'id': self.EOI_STATUS_DRAFT, 'name': 'Draft', 'className': 'text-primary'},
            {'id': self.EOI_STATUS_TRANSFERRED, 'name': 'Transferred', 'className': 'text-primary'},
            {'id': self.EOI_STATUS_SUBMITTED, 'name': 'Submitted', 'className': 'text-success'},
            {'id': self.EOI_STATUS_VERIFIED, 'name': 'Verified', 'className': 'text-primary'},
            {'id': self.EOI_STATUS_WITHDRAWN, 'name': 'Withdrawn', 'className': 'text-success'},
            {'id': self.EOI_STATUS_REJECTED, 'name': 'Rejected', 'className': 'text-danger'},
            {'id': self.EOI_STATUS_REGISTERED, 'name': 'Registered', 'className': 'text-primary'},
            {'id': self.EOI_STATUS_SUCCESSFUL, 'name': 'Successful', 'className': 'text-success'},
            {'id': self.EOI_STATUS_UNSUCCESSFUL, 'name': 'Unsuccessful', 'className': 'text-danger'},
            {'id': self.EOI_STATUS_COMPLETED, 'name': 'Completed', 'className': 'text-success'},
        ];
    }

    getEoiStatusName(eoiStatus){
        const self = this;

        // Set 'default' value as Draft
        let name = '';

        let status = self.getEoiStatus(eoiStatus);

        if(status){
            name = status.name;
        }

        return name;
    }

    getEoiStatus(eoiStatus){
        const self = this;

        let status = null;

        if(!eoiStatus){
            return status;
        }

        try{
            status = self.EOIS_STATUSES.find(x => x.id == eoiStatus);
        }
        catch(ex){
            console.log(ex);
        }

        return status;
    }

    getEoiStatusClass(eoiStatus){
        const self = this;

        let className = 'text-primary';

        let status = self.getEoiStatus(eoiStatus);
        if(status){
            className = status.className;
        }

        return className;
    }

    exportEois(launch_id){
        const self = this;

        let url = "sec/developer/eois/download?property_id="+self.propertyIdForEoi+"&property_launch_id="+launch_id+"&status="+self.eoisStatusnum.join();
        url = self.SSHttpService.getApiURL(url);
        self.$window.location.href  = url;
        self.SSAlertService.success('Success!', 'EOIs export successfully.');
    }

    agencyHederInfo(header)
    {
        const self = this;
        let agencyName = '';
        let message = '';
        if(header == 'EOI COUNT'){
            agencyName = 'EOI COUNT';
            message = 'Total Number of EOI Applications.';

        }else if(header == 'VERIFIED'){
            agencyName = 'VERIFIED';
            message = 'Total Number of EOI Verified by Team IC.';

        }else if(header == 'REGISTERED'){
            agencyName = 'REGISTERED';
            message = 'Total Number of EOI Registered.';

        }else if(header == 'BALLOTED'){
            agencyName = 'BALLOTED';
            message = 'Total Number of EOI Balloted.';

        }else if(header == 'UNIT ALLOCATED'){
            agencyName = 'UNIT ALLOCATED';
            message = 'Total Number of EOIs where units are allocated.';

        }else if(header == 'COMPLETED'){
            agencyName = 'COMPLETED';
            message = 'Total Number of completed EOIs.';
        }

        self.SSConfirmationService.getConfirmed(
            agencyName,
            message,
            self.SSConfirmationService.TYPE_INFO,
            function (selectedOption) {
            }
        );

    }

    getEBallotingValidation() {
        const self = this;

        self.eoiDateCheck = false;

        if (!self.phase_master
            || !self.phase_master.property_launches
        ) {
            return;
        }

        $.each(self.phase_master.property_launches, function (i, phase) {

            if (phase.id == parseInt(self.launch_id)) {

                var currentDateUtc = moment().utc().format('YYYY-MM-DD HH:mm:ss')
                var eoiEndDateUtc = moment(phase.eoi_end_date).format('YYYY-MM-DD HH:mm:ss');
                var launchEndDateUtc = moment(phase.launch_end_date).format('YYYY-MM-DD HH:mm:ss');

                if (currentDateUtc > eoiEndDateUtc
                    && currentDateUtc <= launchEndDateUtc
                ) {
                    self.eoiDateCheck = true;
                }
            }
        });
    }

    // To show/hide print and email buttons
    isPrintButtonAllowed(eoi) {
        const self = this;

        return eoi.status == self.EOI_STATUS_SUBMITTED
            || eoi.status == self.EOI_STATUS_VERIFIED
            || eoi.status == self.EOI_STATUS_REGISTERED;
    }

    downloadSingleEoi(eoi){
        const self = this;
    
        let url = self.SSHttpService.getApiURL('sec/eois/' + eoi.eoi_no + '/print');
        window.open(url, '_blank');
    
        self.SSAlertService.success("Success!", "Download completed successfully");
    }
    emailSingleEoi(eoi){
        const self = this;

        let url = self.SSHttpService.getApiURL('sec/eois/' + eoi.eoi_no + '/print-and-email');
        window.open(url, '_blank');

        self.SSAlertService.success("Success!", "Download and Email sent successfully");
    }

    /**
     * Download the EOI export for the selected phase: the Unit x choice matrix, one row per EOI
     * choice, the Stack / Bedroom Type breakdowns and the Elevation Chart.
     *
     * WEB-4671 folded the separate EOI Raw Data download (WEB-4461) into this one, so the page has
     * a single button again. The sheets that count follow the heatmap's radios through
     * `choice_mode`, so the file counts exactly what the heatmap shows.
     *
     * @param {number} propertyId
     * @param {number} launchId
     * @param {number} first      The heatmap's ctrl.first - 2 = Show by First Choice, 1 = All Choices.
     */
    downloadEOIChoicesByUnit(propertyId, launchId, first){
        if(!propertyId || !launchId){
            this.SSAlertService.error("Error!", "Launch Selection is required.");
            return;
        }
        const self = this;
        let url = self.SSHttpService.getReportURL('api/reports/eoi-export-choices-by-unit-report');
        url += '&property_id='+propertyId;
        url += '&property_launch_id='+launchId;
        url += '&choice_mode=' + (first == 2 ? 'first' : 'all');
        let url_ping = window.open(url,'_blank');
        if(url_ping)
        {
            self.SSAlertService.success("Success!", "Download completed successfully");
        }
    }

}

DeveloperPropertyEoiController.$inject = ['$scope','$localStorage', '$window', '$timeout', '$filter', 'SSHttpService', 'SSConfigService', 'SSUtilService', 'SSAppService', 'SSAlertService', 'OTPService', 'SSConfirmationService', 'SSUserService', 'SSAnalyticsService', 'SSStackviewService'];
app.controller('DeveloperPropertyEoiController', DeveloperPropertyEoiController);

// WEB-4411/WEB-4414: `datepicker` is registered once, globally, by services/key_handover.js.
// A copy here would link it a second time on every element.

/*
app.directive('dateformat', function (dateFilter) {
    return {
        require:'ngModel',
        link:function (scope, elm, attrs, ctrl) {

            var dateFormat = attrs['date'] || 'dd/MM/yyyy';

            ctrl.$formatters.unshift(function (modelValue) {
                return dateFilter(modelValue, dateFormat);
            });
        }
    };
})
*/